module.exports = __webpack_public_path__ + "static/CircularPro-BoldItalic.8de3bf6b.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BoldItalic.woff2
// module id = 723
// module chunks = 168707334958949